(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.email-signup__form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var container = form.closest('.email-signup-block');
      var successEl = container.querySelector('.email-signup__ajax-success');
      var errorEl = container.querySelector('.email-signup__ajax-error');
      var button = form.querySelector('.email-signup__button');

      // Hide any previous messages
      successEl.style.display = 'none';
      errorEl.style.display = 'none';

      // Disable button during request
      button.disabled = true;

      function sendForm() {
        var freshData = new FormData(form);

        fetch(form.action, {
          method: 'POST',
          body: freshData
        })
        .then(function(response) {
          if (response.ok && response.url && response.url.includes('customer_posted=true')) {
            successEl.style.display = 'flex';
            form.querySelector('input[type="email"]').value = '';
          } else if (response.url && response.url.includes('/challenge')) {
            window.location.href = response.url;
          } else {
            throw new Error('signup_failed');
          }
        })
        .catch(function() {
          errorEl.style.display = 'flex';
        })
        .finally(function() {
          button.disabled = false;
        });
      }

      // Use Shopify's captcha protect if available
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form, function() {
          sendForm();
        });
      } else {
        // Captcha not loaded (e.g. theme preview mode) — submit natively
        // and let Shopify handle it on the published theme
        sendForm();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!window.__horizonFacetsPanelInit) {
    window.__horizonFacetsPanelInit = true;

    // ── Batch-apply mode for the dropdown panel ──
    // Patch updateFilters() on the panel's facets-form-component to a no-op.
    // Checkbox changes accumulate silently; AJAX only fires on "Done" click.
    function patchPanelBatchMode() {
      document.querySelectorAll('.facets-dropdown-panel facets-form-component, .facets--drawer facets-form-component').forEach((fc) => {
        if (fc.__horizonBatchPatched) return;
        // Element must be upgraded (have updateFilters as own property)
        if (typeof fc.updateFilters !== 'function') return;
        fc.__horizonBatchPatched = true;
        fc.__originalUpdateFilters = fc.updateFilters;
        fc.updateFilters = () => {}; // no-op until "Done"
      });
    }

    // Wait for custom element to be defined + upgraded, then patch
    customElements.whenDefined('facets-form-component').then(() => {
      requestAnimationFrame(() => {
        patchPanelBatchMode();
      });
    });

    // Re-patch after Shopify AJAX morph replaces DOM (new instances lose patch)
    new MutationObserver(() => {
      requestAnimationFrame(patchPanelBatchMode);
    }).observe(document.body, { childList: true, subtree: true });

    // ── Panel toggle (FILTER button + Done button) ──
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-panel-target]');
      if (!btn) return;
      if (window.innerWidth < 1025) return; // mobile uses drawer
      e.preventDefault();
      e.stopImmediatePropagation();
      const panel = document.getElementById(btn.dataset.panelTarget);
      if (!panel) return;
      const isOpen = panel.classList.toggle('facets-dropdown-panel--open');
      panel.setAttribute('aria-hidden', String(!isOpen));
      btn.setAttribute('aria-expanded', String(isOpen));

      // "Done" closes the panel and batch-applies all pending filters
      if (!isOpen && btn.classList.contains('facets-dropdown-panel__done')) {
        const fc = panel.querySelector('facets-form-component');
        if (fc && fc.__originalUpdateFilters) {
          fc.__originalUpdateFilters();
        }
      }
    });

    // ── Price range bucket checkboxes ──
    // Radio-like behavior + hidden input sync.
    // The stock on:change calls updateFilters() which is now a no-op in panel.
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.price-range-buckets__input');
      if (!input) return;
      const container = input.closest('.price-range-buckets');
      const gteHidden = container.querySelector('[data-price-gte]');
      const lteHidden = container.querySelector('[data-price-lte]');
      const allInputs = container.querySelectorAll('.price-range-buckets__input');

      allInputs.forEach((cb) => { if (cb !== input) cb.checked = false; });

      if (input.checked) {
        gteHidden.value = input.dataset.gte;
        lteHidden.value = input.dataset.lte;
      } else {
        gteHidden.value = '';
        lteHidden.value = '';
      }
    });

    // ── Offers toggle ──
    // Calls updateFilters() which is a no-op inside the panel.
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.offers-toggle__input');
      if (!input) return;
      const facetsForm = input.closest('facets-form-component');
      if (facetsForm && facetsForm.updateFilters) facetsForm.updateFilters();
    });
  }

  /* Color swatches scroll detection — toggle fade + hint when scrolled to bottom */
  {
    const initSwatchScroll = () => {
      document.querySelectorAll('.color-swatches-list').forEach((list) => {
        if (list.dataset.scrollInit) return;
        list.dataset.scrollInit = 'true';
        const wrapper = list.closest('.color-swatches-list-wrapper');
        if (!wrapper) return;

        const check = () => {
          const atEnd = list.scrollHeight - list.scrollTop - list.clientHeight < 8;
          wrapper.classList.toggle('is-scrolled-end', atEnd);
        };

        list.addEventListener('scroll', check, { passive: true });
        check();

        /* Click on hint scrolls the list down */
        const hint = wrapper.querySelector('.color-swatches-scroll-hint');
        if (hint) {
          hint.addEventListener('click', () => {
            list.scrollBy({ top: 150, behavior: 'smooth' });
          });
        }
      });
    };

    initSwatchScroll();
    /* Re-init after section re-renders (view transitions, facet updates) */
    document.addEventListener('shopify:section:load', initSwatchScroll);

    /* Observe only the facets containers instead of the entire body */
    const facetsRoot = document.querySelector('.facets-dropdown-panel') || document.querySelector('.facets--drawer');
    if (facetsRoot) {
      new MutationObserver(initSwatchScroll).observe(facetsRoot, { childList: true, subtree: true });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
